import { view } from '@yola/ws-sdk';
import applyAttributesToElement from './apply-attributes-to-element';

const createElementWithAttributes = (tagName, attributes = {}) => {
  const liveDocument = view.accessors.getLiveDocument();
  const element = liveDocument.createElement(tagName);

  applyAttributesToElement(element, attributes);

  return element;
};

const createIframeElement = (attributes = {}) => createElementWithAttributes('iframe', attributes);

const createWsIframeElement = (attributes = {}) => {
  const wsIframeElement = createElementWithAttributes('ws-iframe', attributes);
  const iframeElement = createIframeElement(attributes);

  wsIframeElement.appendChild(iframeElement);

  return wsIframeElement;
};

export { createIframeElement, createWsIframeElement };
